export const reviewStatusMap = {
  0: '待复核',
  1: '复核正常',
  2: '复核异常',
}

export const workOrderExportHeader = [
  { label: '复核任务ID', key: 'id' },
  { label: '工单ID', key: 'orderid' },
  { label: '任务名称', key: 'title' },
  { label: '所属项目', key: 'projectname' },
  { label: '所属批次', key: 'batchname' },
  { label: '赏金', key: 'salary' },
  { label: '审核通过时间', key: 'reviewedtime' },
  { label: '城市', key: 'cityname' },
  { label: '门店名称', key: 'marketname' },
  { label: '复核状态', key: 'review_status' },
  { label: '复核人', key: 'adminname' },
  { label: '复核完成时间', key: 'review_complete_time' },
]

export default {
  data () {
    return {
      reviewStatusMap,
      exportHeader: workOrderExportHeader.map(item => { return {text: item.label, ...item} }),
    }
  },
}



// WEBPACK FOOTER //
// ./src/views/task/review-task.mixins.js